export default __webpack_public_path__ + "static/MC_dla2_small-8fb8068633b1508ba91188afdcba6558.png";